import { FC } from 'react';

import { Box, List, ListItem, Typography } from '@mui/material';
import clsx from 'clsx';

import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { IGanttChartMobileCardProps as IProps } from './types';
import { getMMYYYYformattedDate } from '../../helpers';
import { GANTT_CHART_STATUSES } from '../../types';
import { GanttChartMobileRow } from '../GanttChartMobileRow';

import styles from './GanttChartMobileCard.module.scss';

export const GanttChartMobileCard: FC<IProps> = ({ chartData, variant, status, MobileCardWrapper }) => {
  const isOutlined = variant === STYLE_VARIANTS.OUTLINED;

  return (
    <MobileCardWrapper>
      <Box className={styles.innerWrapper}>
        <Typography
          variant="h4"
          className={clsx(styles.cardTitle, {
            [styles.uppercase]: !isOutlined,
            [styles.todo]: status === GANTT_CHART_STATUSES.TO_DO,
            [styles.done]: status === GANTT_CHART_STATUSES.DONE,
            [styles.inProgress]: status === GANTT_CHART_STATUSES.IN_PROGRESS,
          })}
        >
          {status}
        </Typography>
        <List className={styles.list}>
          {chartData.map(({ stage, from, to }, i) => (
            <ListItem key={i} className={styles.listItem}>
              <GanttChartMobileRow stage={stage} from={getMMYYYYformattedDate(from)} to={getMMYYYYformattedDate(to)} />
            </ListItem>
          ))}
        </List>
      </Box>
    </MobileCardWrapper>
  );
};
